import { createSelector } from '@reduxjs/toolkit';
import {
  ALL_LOCATION,
  DROPDOWN_OPTIONS,
} from '@/constant/global/global.constant';
import { RootState } from '../types';

const getLocations = function (state: RootState) {
  return state?.location;
};

export const getLocationDetail = createSelector(getLocations, (location) => {
  const list = location?.locations?.data;
  const val = [...list]?.sort((a, b) => a?.name.localeCompare(b?.name));
  const loc = [ALL_LOCATION]?.concat(val as any[]);
  return loc;
});

export const getLocationDetailsWithPagination = createSelector(
  getLocations,
  (location) => {
    return location;
  },
);

export const getLocationsListDetail = createSelector(
  getLocations,
  (reduxStoreData) => {
    const allDevicesList = reduxStoreData?.locationsList?.data?.map(
      (location) => ({
        id: location?.locationId,
        name: location?.name,
        sourceId: location?.sourceId,
      }),
    );
    return {
      allLocationsListData: [
        DROPDOWN_OPTIONS.ALL_LOCATION_DROPDOWN_OPTION,
      ].concat(allDevicesList),
      pagination: reduxStoreData?.locationsList?.pagination,
      loading: reduxStoreData.loading,
    };
  },
);

export const getlocationsListErrorDetails = createSelector(
  getLocations,
  (location) => {
    const locationsListErrorData = {
      error: location?.error,
      message: `Locations : ${location?.message}`,
    };
    return locationsListErrorData;
  },
);
